module.exports = __webpack_public_path__ + "static/media/plate.feafe85a.svg";